module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_error-e4dd51f46566ed3ceacdc900bf2fdf01.png";